module.exports = __webpack_public_path__ + "img/gmepc.51c70955.png";